/**
 * @generated SignedSource<<3208b105356bb04f61e145995a7e2da0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ConnectWalletContent_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"WithWalletConnectionEnsuredModalBase_viewer">;
  readonly " $fragmentType": "ConnectWalletContent_viewer";
};
export type ConnectWalletContent_viewer$key = {
  readonly " $data"?: ConnectWalletContent_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConnectWalletContent_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConnectWalletContent_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WithWalletConnectionEnsuredModalBase_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "8741760d39378a851a5f706880b7b587";

export default node;
